import { Injectable } from "@angular/core";

@Injectable()
export class MessagesService {
  private messages = [
    {
      name: "MCWG Group",
      text: "A new member was added for confirmation. Proceed verification for this group for more actions",
      time: "1 min ago",
      router: "/group/applications/cdo",
    },
    {
      name: "SMGH",
      text: "Proceed verification for loan group for more actions",
      time: "2 hrs ago",
      router: "/group/applications/cdo",
    },
  ];

  public getMessages(): Array<Object> {
    return this.messages;
  }
}
